module.exports = __webpack_public_path__ + "img/download.5bed3128.svg";